const INITIAL_STATE = {
    volume: {},
    grossWeight: 0,
    netWeight: 0,
    volumeConfiguration: {
        packingId: null,
        marketplaceId: null,
        registrationRequired: undefined,
        date: null
    },
    volumeItems: [],
    volumeRegistrations: [],
    marketplace: [],
    packing: [],
    volumeType: []
};

export default function volumeReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'ADD_VOLUME_ITEMS': {
            const items = [];
            let grossWeightTotal = state.grossWeight || 0;
            let netWeightTotal = state.netWeight || 0;
            Object.assign(items, state.volumeItems);
            if (items.filter((f) => f.codigoCartellino === action.volumeItem.codigoCartellino).length === 0) {
                items.push(action.volumeItem);
                if (action.volumeItem.quantidadeUtilizada && action.volumeItem.desenho?.unitWeight) {
                    const totalAdd = action.volumeItem.quantidadeUtilizada * action.volumeItem.desenho.unitWeight;
                    netWeightTotal = parseFloat(((state.netWeight + totalAdd)).toFixed(2));
                    grossWeightTotal = parseFloat(((state.grossWeight + totalAdd)).toFixed(2));
                }
            }
            return {
                ...state,
                grossWeight: grossWeightTotal,
                netWeight: netWeightTotal,
                volumeItems: items
            };
        }
        case 'REMOVED_VOLUME_ITEMS': {
            let grossWeightTotal = state.grossWeight || 0;
            let netWeightTotal = state.netWeight || 0;
            const items = state.volumeItems.filter((item) => item.codigoCartellino !== action.volumeItem?.codigoCartellino);
            if (action.volumeItem.quantidadeUtilizada && action.volumeItem.desenho?.unitWeight) {
                const totalRemoved = action.volumeItem.quantidadeUtilizada * action.volumeItem.desenho.unitWeight;
                netWeightTotal = parseFloat(((state.netWeight - totalRemoved)).toFixed(2));
                grossWeightTotal = parseFloat(((state.grossWeight - totalRemoved)).toFixed(2));
            }
            return {
                ...state,
                grossWeight: grossWeightTotal,
                netWeight: netWeightTotal,
                volumeItems: items
            };
        }
        case 'ADD_VOLUME_REGISTRATIONS': {
            const items = [];
            Object.assign(items, state.volumeRegistrations);
            if (items.filter((f) => f.registration === action.volumeRegistration?.registration).length === 0) {
                items.push(action.volumeRegistration)
            }
            return {
                ...state,
                volumeRegistrations: items
            };
        }
        case 'REMOVED_VOLUME_REGISTRATIONS': {
            const items = state.volumeRegistrations.filter((item) => item.registration !== action.volumeRegistration?.registration);
            return {
                ...state,
                volumeRegistrations: items
            };
        }
        case 'UPDATE_VOLUME_CONFIGURATION': {
            const item = {};
            Object.assign(item, action.volumeConfiguration);
            return {
                ...state,
                volumeConfiguration: item
            };
        }
        case 'SET_MARKETPLACE': {
            return {
                ...state,
                marketplace: action.marketplace
            };
        }
        case 'SET_PACKING': {
            return {
                ...state,
                packing: action.packing
            };
        }
        case 'UPDATE_WEIGHT': {
            let grossWeightTotal = 0;
            let netWeightTotal = 0
            if (state.volumeItems.length > 0) {
                state.volumeItems.item.foreach((item) => {
                    const totalAdd = item.quantidadeUtilizada * item.desenho.unitWeight;
                    netWeightTotal = parseFloat((netWeightTotal + totalAdd).toFixed(2));
                });

                grossWeightTotal = netWeightTotal + action.packing.weight
            }
            else {
                grossWeightTotal = action.packing.weight;
            }
            return {
                ...state,
                grossWeight: grossWeightTotal,
                netWeight: netWeightTotal
            };

        }
        case 'RESET_VOLUME': {
            return {
                ...state,
                volumeRegistrations: [],
                volumeItems: [],
                volume: {},
                volumeConfiguration: {},
                grossWeight: 0
            };
        }
        case 'SET_VOLUME_TYPE': {
            return {
                ...state,
                volumeType: action.volumeType
            };
        }
        default:
            return state;
    }
}
